import { useMemo } from 'react'

import { cn } from '@/utils/ui/styles'

import { getUserInitials } from '@/shared/auth/utils/user'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

import type { User } from '@/shared/auth/types'

export function UserAvatar({
	user,
	avatar,
	className,
}: {
	user: User
	avatar: string
	className?: string
}) {
	const userInitials = useMemo(() => getUserInitials(user), [user])

	return (
		<Avatar className={cn('relative size-8 rounded-lg', className)}>
			<AvatarImage src={avatar} alt={user.fname} />
			<AvatarFallback className="rounded-lg outline-0">
				{userInitials}
			</AvatarFallback>
		</Avatar>
	)
}
